import { type RegistryResponse, fetchRegistry } from '@/lib/resources'
import { useQuery } from '@tanstack/react-query'

/** Sidebar IA — fetched once per login, cached forever. */
export function useResourceRegistry() {
  return useQuery<RegistryResponse>({
    queryKey: ['admin-resource-registry'],
    queryFn: fetchRegistry,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: 60 * 60_000
  })
}
